import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../api/apiInterceptor";
import {displayNotification} from "./notification";

export const fetchDeviceByLocationId = createAsyncThunk(
    "fetchDeviceByLocationId",
    async ({installationId, locationId}) => {
        const result = await api.get(`api/installations/${installationId}/locations/${locationId}/devices`);

        return result.data;
    }
)
export const fetchDeviceTypes = createAsyncThunk(
    "fetchDeviceTypes",
    async () => {
        const response = await api.get(`/api/devicetypes`);
        return response.data;
    }
)
export const createDevice = createAsyncThunk(
    "createDevice",
    async ({installationId, locationId, data}, {dispatch}) => {
        const response = await api.post(`/api/installations/${installationId}/locations/${locationId}/devices`, data);
        dispatch(fetchDeviceByLocationId({installationId, locationId}));
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Uređaj uspješno kreiran!",
            title: "Kreiranje uređaja!"
        }));
        dispatch(hideModal());
    }
)
export const updateDevice = createAsyncThunk(
    "updateDevice",
    async ({installationId, locationId, deviceId, data}, {dispatch}) => {
        await api.put(`/api/installations/${installationId}/locations/${locationId}/devices/${deviceId}`, data)
        dispatch(fetchDeviceByLocationId({installationId, locationId}));
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Uređaj uspješno ažuriran!",
            title: "Ažuriranje uređaja!"
        }));
        dispatch(hideModal());
    }
)
export const deleteDevice = createAsyncThunk(
    "deleteDevice",
    async ({installationId, locationId, deviceId}, {dispatch}) => {
        await api.delete(`/api/installations/${installationId}/locations/${locationId}/devices/${deviceId}`)
        dispatch(displayNotification({
            notificationStatus: "success",
            message: "Uređaj uspješno obrisan!",
            title: "Brisanje uređaja!"
        }));
        dispatch(fetchDeviceByLocationId({installationId, locationId}));
    }
)

export const devicesSlice = createSlice({
    name: "devices",
    initialState: {
        devices: [],
        deviceTypes: [],
        device: null,
        loading: false,
        deviceTypeLoading: false,
        showModal: false,
        editing: false,
        showDeviceDeleteModal: false,
        errorMessage: "",
    },
    reducers: {
        setDevice: (state, action) => {
            state.device = action.payload;
            state.editing = true;
        },
        openModal: (state) => {
            state.showModal = true;
        },
        hideModal: (state) => {
            state.showModal = false;
            state.editing = false;
            state.device = null;
        },
        setDeleteModalStatus: (state, action) => {
            state.showDeviceDeleteModal = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchDeviceByLocationId.pending, (state) => {
            state.loading = true;
        })
            .addCase(fetchDeviceByLocationId.fulfilled, (state, action) => {
                state.loading = false;
                state.devices = action.payload;
            })
            .addCase(fetchDeviceByLocationId.rejected, (state) => {
                state.loading = false;
            }).addCase(fetchDeviceTypes.pending, (state) => {
            state.deviceTypeLoading = true;
        })
            .addCase(fetchDeviceTypes.fulfilled, (state, action) => {
                state.deviceTypeLoading = false;
                state.deviceTypes = action.payload;
            })
            .addCase(deleteDevice.fulfilled, state => {
                state.showDeviceDeleteModal = false;
            })
    }
})
export const {openModal, hideModal, setDevice, setDeleteModalStatus} = devicesSlice.actions;
export default devicesSlice.reducer;